module.exports = __webpack_public_path__ + "media/images/arrow@3x-3c3c1dcff0ce2fbe18547faf53a3a8b3.png";